<div class="document-upload-prompt">
  <!-- Header -->
  <div class="prompt-header" [class.first-login]="isFirstLogin">
    <div class="icon-container">
      <mat-icon *ngIf="isFirstLogin" class="welcome-icon">celebration</mat-icon>
      <mat-icon *ngIf="!isFirstLogin" class="document-icon">folder_open</mat-icon>
    </div>
    <h2 mat-dialog-title *ngIf="isFirstLogin">Welcome{{ staffName ? ', ' + staffName : '' }}! 🎉</h2>
    <h2 mat-dialog-title *ngIf="!isFirstLogin">Action Required</h2>
  </div>

  <mat-dialog-content>
    <!-- First Login Message -->
    <div *ngIf="isFirstLogin" class="welcome-message">
      <p class="main-text">
        Welcome to the team! Before you get started, please upload your identity documents for verification.
      </p>
    </div>

    <!-- Pending Documents List -->
    <div class="pending-documents" *ngIf="pendingDocuments.length > 0">
      <h4>📋 Documents Required:</h4>
      <ul class="document-list">
        <li *ngFor="let doc of pendingDocuments" class="document-item">
          <mat-icon class="doc-icon">insert_drive_file</mat-icon>
          <span>{{ doc.document_name }}</span>
          <span class="required-badge">Required</span>
        </li>
      </ul>
    </div>

    <!-- Info Box -->
    <div class="info-box">
      <mat-icon>info</mat-icon>
      <p>
        Uploading your documents helps us verify your identity and ensures smooth onboarding. 
        This is a one-time process.
      </p>
    </div>

    <!-- Don't Show Again Checkbox (only for non-first login) -->
    <!-- <div *ngIf="!isFirstLogin" class="checkbox-container">
      <mat-checkbox [(ngModel)]="dontShowAgain">
        Don't remind me for 7 days
      </mat-checkbox>
    </div> -->
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <!-- <button mat-button color="basic" (click)="skipForNow()" *ngIf="isFirstLogin">
      Skip for now
    </button>
    <button mat-button color="basic" (click)="remindLater()" *ngIf="!isFirstLogin">
      Remind me later
    </button> -->
    <button mat-flat-button color="primary" (click)="goToDocuments()">
      <mat-icon>upload_file</mat-icon>
      Upload Documents
    </button>
  </mat-dialog-actions>
</div>
